module.exports = "/images/vendor/flag-icon-css/flags/4x3/rw.svg?7fe5146baf52818fc8f0845a0b36d3da";